module.exports = __webpack_public_path__ + "fonts/Artifakt-Element-Regular.5df10b32.woff";